import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { BounceOutMode } from "./BounceOutMode";
import { DestroyOutMode } from "./DestroyOutMode";
import { NoneOutMode } from "./NoneOutMode";
import { OutOutMode } from "./OutOutMode";
export var OutOfCanvasUpdater = /*#__PURE__*/function () {
  function OutOfCanvasUpdater(container) {
    var _this = this;

    _classCallCheck(this, OutOfCanvasUpdater);

    this.container = container;

    this._updateOutMode = function (particle, delta, outMode, direction) {
      var _iterator = _createForOfIteratorHelper(_this.updaters),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var updater = _step.value;
          updater.update(particle, direction, delta, outMode);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    this.updaters = [new BounceOutMode(container), new DestroyOutMode(container), new OutOutMode(container), new NoneOutMode(container)];
  }

  _createClass(OutOfCanvasUpdater, [{
    key: "init",
    value: function init() {}
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      return !particle.destroyed && !particle.spawning;
    }
  }, {
    key: "update",
    value: function update(particle, delta) {
      var _outModes$bottom, _outModes$left, _outModes$right, _outModes$top;

      var outModes = particle.options.move.outModes;

      this._updateOutMode(particle, delta, (_outModes$bottom = outModes.bottom) !== null && _outModes$bottom !== void 0 ? _outModes$bottom : outModes.default, "bottom");

      this._updateOutMode(particle, delta, (_outModes$left = outModes.left) !== null && _outModes$left !== void 0 ? _outModes$left : outModes.default, "left");

      this._updateOutMode(particle, delta, (_outModes$right = outModes.right) !== null && _outModes$right !== void 0 ? _outModes$right : outModes.default, "right");

      this._updateOutMode(particle, delta, (_outModes$top = outModes.top) !== null && _outModes$top !== void 0 ? _outModes$top : outModes.default, "top");
    }
  }]);

  return OutOfCanvasUpdater;
}();